import { CSSProperties } from 'react';

export const containerStyle: CSSProperties = {
  display: 'flex',
  marginTop: '12px',
  minHeight: '48px',
  alignItems: 'center',
  position: 'relative',
};

export const contentStyle: CSSProperties = {
  width: '100%',
  textAlign: 'left',
};

export const titleWrapperStyle: CSSProperties = {
  padding: '0 0 2px 0',
  margin: 0,
  lineHeight: '1.2',
  display: 'flex',
  flexDirection: 'column'
};

export const titleStyle: CSSProperties = {
  fontSize: '16px',
  fontWeight: 700
};

export const subtitleStyle: CSSProperties = {
  fontSize: '13px',
  fontWeight: 400,
  color: '#707070',
  marginTop: '2px',
};

export const timestampStyle: CSSProperties = {
  color: '#a0a0a0',
  fontSize: '12px',
  margin: 0,
};

export const incomeAmountStyle: CSSProperties = {
  fontSize: '14px',
  fontWeight: 'bold',
  color: '#62d44d',
  whiteSpace: 'nowrap',
};

export const outcomeAmountStyle: CSSProperties = {
  fontSize: '14px',
  fontWeight: 'bold',
  color: '#FF6B6A',
  whiteSpace: 'nowrap',
};

export const amountValueStyle: CSSProperties = {
  fontWeight: 'bold',
};